import { Roles } from 'shared/enums/Roles';

export const tablesType = {
  userTable: {
    name: 'USER_TABLE',
    roles: [Roles.END_USER_ADMIN, Roles.SUBMISSION_DRAFTER, Roles.SUBMISSION_SENDER, Roles.SUBMISSION_SIGNER],
  },
  invitationTable: {
    name: 'INVITATIONS_TABLE',
    roles: [Roles.END_USER_ADMIN],
  },
};

export const showTab = (tab, currentOrganization) => {
  switch (tab.name) {
    case 'USER_TABLE': {
      return true;
    }

    case 'INVITATIONS_TABLE': {
      return !(currentOrganization?.type === 'INDIVIDUAL');
    }

    default: {
      return true;
    }
  }
};
